import React from 'react';

const StatusDisplay = ({ status }) => (
    <p>Status: {status}</p>
);

export default StatusDisplay;
